import { switchCurrentAccount } from '@core/api/account';

/**
 * @ngdoc service
 * @name adjust.service:ErrorInterceptor
 *
 * @description
 * Global error interceptor that caches all 500 GET
 * requests and redirects them to error page without url changing
 *
 */
function ErrorInterceptor($injector, $q, $window) {
  'ngInject';
  return {
    responseError: responseError,
  };

  /**
   * @ngdoc method
   * @name responseError
   * @methodOf adjust.service:ErrorInterceptor
   *
   * @description
   * Response error callback function, send user to appropriate page
   *
   * @param {Object} rejection rejection details
   * @param {number} rejection.data response data
   * @param {number} rejection.status http status code
   * @param {Object} rejection.config rejection configuration
   * @param {string} rejection.config.method request method
   * @param {string} rejection.config.url request url
   * @param {Object} rejection.config.params request parameters
   * @returns {promise}
   */
  function responseError(rejection) {
    const statusRegEx = /^[1-5][0-9][0-9]$/;
    const isApptrace = rejection.config?.url?.includes('apptrace.com');
    const isInvalidConfig = !(
      statusRegEx.test(rejection.status) &&
      rejection.config &&
      rejection.config.method === 'GET'
    );
    const $state = $injector.get('$state');

    if (isApptrace || isInvalidConfig) {
      return $q.reject(rejection);
    }

    if (rejection.status === 403 && rejection.config.redirectOnPermissionError) {
      return switchCurrentAccount($state.params.account_id).then(() => $q.reject(rejection));
    }

    if (rejection.status === 404) {
      if (!rejection.config.ignore404) {
        $window.location.href = '/404.html';
      }
    } else {
      if (rejection.status !== 401 && rejection.config.critical) {
        $state.go('errorPage', {}, { location: false });
      }
    }

    return $q.reject(rejection);
  }
}

export { ErrorInterceptor };
